module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.event && !_vm.event.deleted) ? _c('div', {
    staticClass: "up__event"
  }, [_c('div', {
    staticClass: "up__event-edit"
  }, [_c('timechanger', {
    staticClass: "time-changer__create-presence",
    class: {
      'input-warning': _vm.event.tempIntersect
    },
    attrs: {
      "lang": "da",
      "start": _vm.event.start,
      "end": _vm.event.end,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.updateStart,
      "updateEnd": _vm.updateEnd
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "up__event-delete pointer",
    on: {
      "click": _vm.deleteEvent
    }
  }, [_c('span', {
    staticClass: "icon-cross3"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "up__event-sum"
  }, [_vm._v("\n    " + _vm._s(_vm.duration) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-445cce33!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Presence/User/PresenceUserEditEvent.vue
// module id = 1554
// module chunks = 1